module.exports = __webpack_public_path__ + "static/img/location-prefix.b5c7146d.svg";